<template>
  <div>
    <h1 class="mx-auto center-header text-center general__title">Get a Quote</h1>

    <form @submit.prevent="sendEmail" class="general__form mx-auto" ref="formRef">
      
      <div class="mb-3 general__box">
        <input type="text" id="company_name" class="form-control" name="company_name" placeholder="Company Name" required />
      </div>

     
      <div class="mb-3 general__box">
        <input type="text" id="name" class="form-control" name="name" placeholder="Full Name" />
      </div>

     
      <div class="mb-3 general__box">
        <input type="email" class="form-control" id="email" name="email" placeholder="Email Address" required />
        <div id="emailHelp" class="form-text">
          We'll never share your email, address or phone number with anyone else.
        </div>
      </div>

      
      <div class="mb-3 general__box">
        <vue-tel-input
          v-model="formData.phone"
          :default-country="'ES'"
          placeholder="Enter phone number"
          input-class="form-control"
          name="phone"
          required
        />
      </div>

      
      <div class="mb-3 general__box">
        <input type="text" class="form-control" id="address" name="address" placeholder="Full Address" required />
      </div>

      
      <div class="mb-3 general__box">
        <input type="text" class="form-control" id="county" name="county" placeholder="County" required />
      </div>

      <div class="mb-3 general__box">
        <input type="text" class="form-control" id="country" name="country" placeholder="Country" required />
      </div>

      
      <div class="mb-3 general__box">
        <input type="text" class="form-control" id="postal_code" name="postal_code" placeholder="Postal Code" required />
      </div>

     
      <div class="mb-3 general__box">
        <label for="product" class="form-label">Select your product</label>
        <select id="product" class="form-select" name="product">
          <option selected value="dedicated-lines">Dedicated Line</option>
          <option value="business-broadband">Business Broadband</option>
          <option value="wireless-connect">Wireless Connect</option>
        </select>
      </div>

      
      <div class="mb-3 general__box">
        <label for="contract" class="form-label">Term of contract</label>
        <select id="contract" class="form-select" name="terms" required>
          <option selected value="1 year">1 Year</option>
          <option value="2 years">2 Years</option>
          <option value="3 years">3 Years</option>
        </select>
      </div>

      
      <div class="mb-3 general__box">
        <label for="ip" class="form-label">IP</label>
        <select id="ip" class="form-select" name="ip" required>
          <option selected value="/31">/31</option>
          <option value="/30">/30</option>
          <option value="/29">/29</option>
        </select>
      </div>

     
      <div class="mb-3 general__box">
        <textarea class="form-control" name="message" id="concern" cols="30" rows="5" placeholder="Message"></textarea>
      </div>

      
      <div class="form-check mb-3 general__box">
        <input class="form-check-input" type="checkbox" id="partnerFormAgree" v-model="formData.agreed" required />
        <label class="form-check-label" for="partnerFormAgree">
          Agree to terms and conditions of the
          <router-link to="/privacy-policy">privacy policy</router-link>.
        </label>
      </div>

      
      <div class="text-center">
        <button class="button" type="submit">Submit</button>
      </div>
    </form>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue';
import emailjs from 'emailjs-com';
import Swal from 'sweetalert2';
import { useHead } from '@vueuse/head';

export default {
  name: 'SalesQuote',

  setup() {
    
    const formData = reactive({
      company_name: '',
      name: '',
      email: '',
      phone: '',
      address: '',
      county: '',
      country: '',
      postal_code: '',
      product: 'dedicated-lines',
      terms: '1 year',
      ip: '/31',
      message: '',
      agreed: false,
    });

    const formRef = ref(null);

    // Set page metadata
    onMounted(() => {
      window.scrollTo(0, 0);
    });

    useHead({
      title: 'Sales Quote - inte-QT',
      meta: [
        { name: 'title', content: 'Sales Quote - inte-QT' },
        { name: 'description', content: 'To get a quotation, please contact us by filling in the following form.' },
      ],
      link: [
        { rel: 'canonical', href: 'https://www.inte-qt.com/contact/quote' },
      ],
    });

    // Handle form submission
    const handleSubmit = () => {
      if (formData.agreed) {
        Swal.fire({
          title: 'Success',
          text: 'We have received your form, we will review the information and get back to you soon.',
          icon: 'success',
          timer: 3000,
          timerProgressBar: true,
        });
        sendEmail();
      } else {
        Swal.fire({
          title: 'Wait',
          text: 'You need to fill in all the data',
          icon: 'info',
          timer: 3000,
          timerProgressBar: true,
        });
      }
    };

    // Send email via EmailJS
    const sendEmail = () => {
      emailjs
        .sendForm('service_eqzo3ks', 'template_3y5tfzp', formRef.value, 'sII_fVN7Ct9kkRQpN')
        .then(() => {
          // Reset form after successful submission
          formRef.value.reset();
          formData.phone = '';
          formData.agreed = false;
        })
        .catch((err) => {
          console.error('EmailJS Error:', err);
        });
    };

    return {
      formData,
      formRef,
      handleSubmit,
      sendEmail,
    };
  },
};
</script>

<style scoped>
@import 'vue3-phone-number-input/dist/vue3-phone-number-input.css';

.general__form {
  max-width: 900px;
  width: 46%;
  margin: 40px auto;
  padding: 2rem;
  background-color: #fdfdfd;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}

.form-text {
  font-family: "Poppins", sans-serif;
  font-size: 1.125rem;
  font-weight: 300;
  color: #6c757d;
  margin-top: 0.25rem;
}

.form-check-input {
  border-radius: .25em;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}
.form-check-input {
  width: 1em;
  height: 1em;
  margin-top: .25em;
  vertical-align: top;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0, 0, 0, .25);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.general__box {
  width: 100%;
  margin-bottom: 20px;
}

.form-label {
  font-family: "Poppins", sans-serif;
  font-size: 1.125rem;
  font-weight: 300;
  color: #212529;
  margin-bottom: 0;
  line-height: 1.5;
}

.general__box textarea,
.general__box select,
.general__box .PhoneInput {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-sizing: border-box;
}

.form-check {
  margin-top: 1rem;
}

.button {
  background-color: #007bff;
  border: none;
  color: #fff;
  padding: 0.75rem 2rem;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.2s ease;
}

.button:hover {
  background-color: #0056b3;
}
</style>
